export const menuPresident = {
    menu: [
        {label: 'menu.mesExpertises', icon: '', url: '/dossiers/mes-expertises', children: []},
        {label: 'menu.reunionDuJour', icon: '', url: '/dossiers/mes-expertises-reunion', children: []},
        {label: 'menu.nominer-expertiser', icon: '', url: '/datavis/nommer', children: []},
        {label: 'menu.espaceChercheur', icon: '', url: '/accueil', children: [
            {label: 'menu.OuvrirDossier', url: '/accueil'},
            {label: 'menu.candidatures', url: '/dossiers/candidatures'},
            {label: 'menu.projetsFinances', url: '/dossiers/projets-finances'},
        ]},
    ],
    classKey: 'president'
};

